<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'

const props = defineProps({
  startDate: {
    type: [Date, Number, String],
    default: null
  },
  endDate: {
    type: [Date, Number, String],
    default: () => new Date()
  }
})
const emit = defineEmits({
  progress: () => true,
  done: () => true
})

const timeLeft = ref(0)

let intervalId = null
let targetMs = 0

const stop = () => {
  if (intervalId !== null) {
    clearInterval(intervalId)
    intervalId = null
  }
}

// Remaining time is read from the clock on every tick: background tabs throttle
// timers, so subtracting a fixed second per tick drifts behind real time.
const tick = () => {
  const time = Math.max(targetMs - Date.now(), 0)
  timeLeft.value = time
  emit('progress', { time, totalSeconds: Math.ceil(time / 1000) })
  if (time <= 0) {
    stop()
    emit('done')
  }
}

const countTimeLeft = () => {
  stop()
  const endMs = moment(props.endDate).valueOf()
  targetMs = props.startDate ? Date.now() + (endMs - moment(props.startDate).valueOf()) : endMs
  tick()
  if (timeLeft.value > 0) {
    intervalId = setInterval(tick, 1000)
  }
}

const timeFormat = (time) => {
  return moment.duration(time).format("d [days] h [hours] mm [mins] ss [secs]")
}

onMounted(() => {
  countTimeLeft()
})

onUnmounted(stop)

watch(() => props.endDate, () => {
  countTimeLeft()
})
</script>

<template>
  <span>
    <slot />
    <span v-if="timeLeft > 0">
      {{ timeFormat(timeLeft) }}
    </span>
  </span>
</template>
